export const APIUrl = {
  login: "api/v1/auth/login",
  logOut: "api/v1/auth/logout",
  verify: "api/v1/auth/verify_code",
  resendCode: "api/v1/auth/resend_code",
  forgotPassword: "api/v1/auth/forgetPassword",
  resetPassword: "api/v1/auth/resetPassword",
  verifyResetPasswordCode: "api/v1/auth/reset_password/varify_code",
  getRefreshToken: "api/v1/auth/refreshtoken",
  fetchRefreshToken: "api/v1/auth/refresh_token",
  refreshTimeOut: "api/v1/expiration/time",
  //country
  country: "api/v1/countries",
  contactSupport: "api/v1/noc/contact",
  //loyalty point history
  loyaltyPointHistory:
    "api/v1/admin/info/consumer/details/loyalityPointsHistory",
  //Promo code history
  consumerPromoCodeHistory: "api/v1/admin/info/promocode/details",
  promoValidityUpdate: "api/v1/admin/info/promocode/validity",
  consumerPaymentHistory: "api/v1/admin/info/consumer/payment/history",
  consumerAllTransactions:
    "api/v1/admin/info/consumer/transaction/history/summary",
  //consumer comments
  getConsumer: " api/v1/admin/consumer/comments",
  deleteComments: "api/v1/admin/consumer/comments",
  salesRepretailer: "api/v1/admin/consumer/comments/consumer",
  postComments: "api/v1/admin/consumer/comments/",
  consumerComments: "api/v1/admin/consumer/comments",
  editComments: "api/v1/admin/consumer/comments/",

  //consumer Fee
  paymentTypes: "api/v1/fee/configuration/get/payment/type",
  //Enable Connections
  getConnectionFlag: "api/v1/enable/pir",
  enablePIRConnections: "api/v1/enable/pir",

  //Consumer logs history
  consumersLogsHistory: "api/v1/admin/info/consumer/logs",
  // Top charts
  topRechargees: "api/v1/recharge/topRecharges",
  // Configurations
  uiConfig: "api/v1/uiconfig_values",
  //providers,new, update,
  allProviders: "api/v1/admin/providers/",
  //Active providers,
  activeProviders: "api/v1/admin/providers/status/Active",
  //inActive providers,
  inactiveProviders: "api/v1/admin/providers/status/InActive",
  //get provider data by id {providerId}
  getProvider: "api/v1/admin/providers/",

  allproductsforPricelist: "api/v1/admin/pricelists/products",

  // Download all products excel CSV
  exportAllProducts: "api/v1/admin/products/csv/export",
  // Retailers Grid
  retailerGrid: "api/v1/admin/retailers/grid",
  //Retailers,new, update,
  allRetailers: "api/v1/admin/retailers",
  //get Retailer data by id {retailerId}
  getRetailer: "api/v1/admin/retailers",
  //GET, PUT, POST, DELETE
  // GET "api/v1/admin/salesrep/comments/{commentId}"
  // GET "api/v1/admin/salesrep/comments/{retailerId}"
  // DELETE "api/v1/admin/salesrep/comments/{commentId}"
  // PUT "api/v1/admin/salesrep/comments/"
  // POST "api/v1/admin/salesrep/comments/"
  postsalesRepComments: "api/v1/admin/salesrep/comments/",
  salesRepComments: "api/v1/admin/salesrep/comments",
  salesRepretailerComments: "api/v1/admin/salesrep/comments/retailer",

  //get Retailers list
  retailersList: "api/v1/admin/retailers/list",
  //get retailer business details
  retailerBusinessNames: "api/v1/admin/retailers/businessNames",
  //get all Carrer plans
  carrierPlans: "api/v1/admin/retailers/careerplans",
  //GET pinless carriers
  getpinlessCarriers: "api/v1/carriers/pinless",
  //Pinless carriers - Info portal User Level
  pinlessCarriers: "api/v1/retailer/products/carriers/pinless",
  // Pinless countries - Info portal user level
  pinlessCountries: "api/v1/retailer/products/countries/pinless",
  //Get pinless rates grid
  pinlessRates: "api/v1/admin/products/all/pinlessrates",
  //Pinless rates Excel Upload
  uploadPinlessRates: "api/v1/admin/products/excel/import/pinlessrates",
  //get loyalty Points
  loyaltyPoints: "api/v1/admin/retailers/loyaltyPoints",
  //get retailer balance
  retailerBalance: "api/v1/admin/retailers/balance",
  //get frequent recharge
  frequentRecharge: "api/v1/admin/retailers/frequentrecharge",
  //get list of Config Names
  congifValues: "api/v1/uiconfig_values",
  //Get Sales Reps
  getSalesReps: "api/v1/dispaly_name/sales_reps",
  //get Product Favorites
  productFavorites: "api/v1/admin/retailers/ProductFavorites",
  //Get all products, update, new
  products: "api/v1/admin/products",
  //Products history
  productshistory: "api/v1/admin/products/history",
  //To update product Status InActive
  productStatus: "api/v1/admin/products/inactive",
  //get product data by id
  getProduct: "api/v1/admin/products/",
  //promotions
  promotions: "api/v1/promotions",
  // consumer promotions
  consumerPromotions: "api/v1/consumer/carrier/promotions",
  //get promotions by id
  getPromotions: "api/v1/promotions/",
  //Banners
  getPromotionBanner: "api/v1/admin/promotions/promocode/banners",
  updatePromoCodeBanner: "api/v1/admin/promotions/promocode/banner",
  mapRetailers: "api/v1/admin/promotions/promocode/banners/retailers",
  addBanner: "api/v1/admin/promotions/promocode/banners/save",
  //occations promocodes
  occationcarriers: "api/v1/admin/promotions/occasions/promocode/carriers",

  //Videos
  addVideos: "api/v1/admin/video/instructions",
  getVideos: "api/v1/admin/video/instructions/getAll",
  updateVideos: "api/v1/admin/video/instructions/update",
  getVideoForUpdate: "api/v1/admin/video/instructions/",

  //get all list of distinct pricelist
  pricelistnametype: "api/v1/admin/pricelists/nameandtype",
  //get all list of distinct pricelist
  pricelists: "api/v1/admin/pricelists/",
  //get price list for grid
  gridPricelist: "api/v1/admin/pricelists/grid",

  //update pricelist from grid
  updateProdutPricelist: "api/v1/admin/pricelists/update",
  //get all list of distinct pricelist
  retailerpricelists: "api/v1/admin/pricelists/retailer",
  //get all list of distinct pricelist
  salesrepspricelists: "api/v1/admin/pricelists/salesrep",
  //
  salesrepPricelist: "api/v1/admin/pricelists/salesrep/retailer/pricelist",
  //To get list of pricelist by passing pricelisttype as Retailer or sales Rep as parameter
  pricelistType: "api/v1/pricelists/pricelisttype",
  //To get list of pricelist by passing pricelist name parameter
  pricelistName: "api/v1/admin/pricelists/pricelistname", /// Need confirmation
  //To get list of pricelist by passing pricelist name and product ID parameter
  pricelistProdcuts: "api/v1/pricelists/products",
  pricelistdownloadProdcuts: "api/v1/admin/pricelists/csv/export",
  //To get list of pricelist names.
  namesAndType: "api/v1/pricelists/namesandtype",
  //To get list of carriers.
  carriers: "api/v1/carriers",
  //All countries
  getAllCountries: "api/v1/countries",
  //Carriers By country
  countrycarriers: "api/v1/carriers/international",
  // 'carriers': 'api/v1/carriers/domestic',
  //update price list in bulk.
  bulkpricelists: "api/v1/admin/pricelists/bulkpricelists",
  //import file
  import: "api/v1/admin/pricelists/excel/import",
  //import file
  importproducts: "api/v1/admin/products/excel/import",
  //consumer pricelist
  consumerpricelists: "api/v1/admin/pricelists/consumer",
  // Carrier Promotions
  //Get All Carrier Promotions, Add, update
  carrierPromotions: "api/v1/admin/carrier/promotions",
  //Carrier Promotions By Id /{carrierPromotionId}
  carrierPromotionsId: "api/v1/admin/carrier/promotions",
  // Send promotion messages to users
  notifyMessageToUser: "api/v1/admin/carrier/promotions/notification",
  //Get product details List
  skuList: "api/v1/admin/products/list",
  //Country List
  countryList: "api/v1/admin/products/countries",
  carrierList: "api/v1/admin/products/carriers",
  //productsList:"api/v1/admin/products/list",
  consumerProductList:"api/v1/admin/products/list/consumer",

  //Occasions/ Festivals list
  occasionsList: "api/v1/occasions",
  occasionsRefresh: "api/v1/occasions/refresh",

  festival: "api/v1/admin/occasion",

  // Loyalty rewards
  allLoyaltyRewards: "api/v1/loyalties",
  // Delete Loyalty Rewards

  deleteLoyaltyRewards: "api/v1/loyalties",
  // Loyalty promocodes
  allLoyaltyPromotions: "api/v1/admin/loyalty/promocodes",

  // POST:Generate & Save promocode
  generateSavePromo: "api/v1/admin/promotions/occasions/promocode",

  //Get promocode history
  getPromocodeHistory: "api/v1/admin/promotions/promocodes",

  // POST:?promocodeId=1 //Send promocode notifications
  sendNotificationPromo: "api/v1/admin/promotions/promocodes/notification",

  // GET: ?occasionId=1 promocode details by occasion Id
  occaionPromoCode: "api/v1/admin/promotions/occasions/promocodes",
  // {promocodeId}
  customerHistoryList: "api/v1/admin/promotions/notification/customers",

  // wallet API
  retailerDetails: "api/v1/admin/retailers",
  walletretailerDetails: "api/v1/admin/retailers/wallet",
  retailerAddFunds: "api/v1/retailer/funds/add",
  retailerSalesRepAddFunds: "api/v1/admin/salesreps/funds/add",
  retailerSalesRepRemoveFunds: "api/v1/admin/salesreps/funds/remove",
  retailerRemoveFunds: "api/v1/retailer/funds/remove",
  retailerFundDetailsByretailerAccountNumAndretailerId:
    "api/v1/admin/retailers/details",
  getSalesRepRetailerList: "api/v1/admin/retailers/postpaid",
  // need to implement salesrep retiler list
  // 'getAdminRepRetailerList': 'api/v1/admin/retailers/postpaid',
  getSalesReproleRetailerList: "api/v1/admin/retailers/postpaid/salesrep",
  addRetailerMoney: "api/v1/admin/retailers/fund",
  addSalesRepMoney: "api/v1/admin/salesreps/funds/info",
  // Sales Reps
  getSalesRepsList: "api/v1/admin/salesreps",

  credeitLineReport: "api/v1/admin/salesreps/creditlines",
  //http://52.188.59.223:8081/api/v1/admin/salesreps/1

  // Invoices
  allInvoices: "api/v1/admin/invoices",
  pendingPayments: "api/v1/admin/invoices/pending/payments",
  invoicepayments: "api/v1/admin/invoices/paid/payments",
  approveACHDD: "api/v1/payments/approve",
  rejectACHDD: "api/v1/payments/reject",
  rejectInvoice: "api/v1/admin/invoices/reject",
  itemcodes: "api/v1/admin/invoices/lineitem/codes",
  //User management
  userManage: "api/v1/admin/users",
  //roles
  roles: "api/v1/admin/users/roles",
  //Businessnames
  businessNames: "api/v1/admin/retailers/businessNames",
  // Profiles
  userprofile: "api/v1/admin/userprofile",
  // Password change
  passwordchange: "api/v1/admin/userprofile/change/password",
  // GET: OTP for update password
  getUpdatePasswordOtp: "api/v1/admin/userprofile/password/change/otp",
  // POST: Submit OTP to reset password
  submitUpdatePswdOtp: "api/v1/admin/userprofile/otp/verify",

  resetProfilePassword: "api/v1/admin/userprofile/change/password",
  userUnlock: "api/v1/admin/users/account/unlock",
  getCloseRequest: "api/v1/admin/retailers/closing/grid",
  notifyRetailer: "api/v1/admin/retailers/closing/notification",
  finalizeAccountClose: "api/v1/admin/retailers/update/close/status",
  requestUndoCloseAccount: "api/v1/admin/retailers/update/active/status",
  // Logs
  //GET logs
  logs: "api/v1/admin/userprofile/logs",

  // Invoices
  // New invoice number
  getNewInvoiceNumber: "api/v1/admin/invoices/number",
  //Create nw invoice
  invoice: "api/v1/admin/invoices",

  // POST && GET {invoiceId}
  // Get Invoice Preview on unsaved Invoice
  invoicePreview: "api/v1/admin/invoices/view",

  // preview before save
  invoicePreviewBeforeSave: "api/v1/admin/invoices/view/pdf",

  // Email invoice
  emailInvoice: "api/v1/admin/invoices/email",

  // GET
  // Download Invoice as PDF '/api/v1/admin/invoices/view/{invoiceId}/download'
  downloadPdf: "download",

  // GET
  // Get Invoice Preview as PDF '/api/v1/admin/invoices/view/{invoiceId}/pdf'
  invoicePreviewPdf: "pdf",
  //retailer Usernames {retailerId} Get all users by retailer Id
  retailerUsernames: "api/v1/admin/retailers/users",

  // Retailer portal access verification
  //GET: OTP for retailer access
  getAccessVerifyCode: "api/v1/admin/retailer/accesss/generate/otp",
  // POST Varify OTP for retailer access/
  submitOtpToAccessRetailer: "api/v1/admin/retailer/accesss/verify/otp",

  // Messages
  // GET List of All Messages
  // Compose Message
  //  GET list of users
  userNameList: "api/v1/admin/users/recipients",

  // GET get Messages by Message Id /{messageId}
  allMessages: "api/v1/messages",
  salesrepsList: "api/v1/admin/users/recipients/salesreps",
  //POST send multiple messages to retailers under that sales rep
  messageMultipleRetailers: "api/v1/messages/send/salesrep",
  // GET get Messages by Status
  messageStatus: "api/v1/messages/status",
  // Set messages read
  markMessagesRead: "api/v1/messages/read",
  // GET List of All Received Messages
  receivedMessagegs: "api/v1/receivedMessages",
  // GET List of All Received Messages
  sentMessages: "api/v1/sentMessages",
  // GET List of All Deleted Messages
  deletedMessages: "api/v1/messages/deleted",
  //Attachment upload
  attachment: "api/v1/messages/attachment",
  //flag
  messageflag: "api/v1/messages",
  // delete a single selection
  deleteReceived: "api/v1/deleteReceivedMessage",
  deleteSent: "api/v1/deleteSentMessage",

  paymentHistory: "api/v1/payments",
  // Retailer transactinos
  getAllTransactions: "api/v1/retailers/transactions",
  getTransactionSummary: "api/v1/retailers/transactions/summary",

  //countryNames
  countryNames: "api/v1/countries",

  //Reports :
  batchExportList: "api/v1/admin/reports/batchExportList",
  createBatchExport: "api/v1/admin/reports/createBatchExport",

  //batchexport : "api/v1/admin/reports/batchExport",
  commissions: "api/v1/admin/reports/commission",
  commissionSummary: "api/v1/admin/reports/commission/summary",

  payments: "api/v1/admin/reports/payment",
  consumerPaymentSummary: "api/v1/admin/reports/consumer/payment/summary",
  consumerPayment: "api/v1/admin/reports/consumer/payment/report",
  paymentSummary: "api/v1/admin/reports/payment/summary",

  reatileracquisition: "api/v1/admin/reports/retialer/acquistion",
  reatileracquisitionSummary: "api/v1/admin/reports/retialer/summary",

  consumerAcquisition: "api/v1/admin/reports/consumer/acquisition/report",

  salesSummary: "api/v1/admin/reports/sales/summary",
  sales: "api/v1/admin/reports/sales",

  loyalitySummary: "api/v1/admin/reports/loyalty/subscriptions",
  loyality: "api/v1/admin/reports/loyalty",

  refundSummary: "api/v1/admin/reports/refund/summary",
  refund: "api/v1/admin/reports/refund",

  //realtimeSummary: "api/v1/admin/reports/realtimeTrasactionsSummerry",
  realtimeSummary: "api/v1/admin/reports/trasactions/summary",

  realtime: "api/v1/admin/reports/realtimeTrasactions",
  pinlessrefund: "api/v1/recharge/pinlessRefund",

  // consumer realtime
  consumerRealTime: "api/v1/admin/reports/consumer/realtimeTrasactions",

  // consumer realtime summary
  consumerRealTimeSummary: "api/v1/admin/reports/consumer/trasactions/summary",

  //consumer transaction history
  consumerTransactionHistory:
    "api/v1/admin/info/consumer/transaction/history/All",

  // Link Account API Endpoints //
  // GET
  // Get Retailer Linked Accounts
  getRetailerLinked: "api/v1/admin/retailer/accounts/",
  // POST
  // Save Retailer Linked Accounts
  linkRetailer: "api/v1/admin/retailer/accounts/link",
  // GET
  // Search By Retailer Name
  searchAllRetailer: "api/v1/admin/retailer/accounts/search",
  // DELETE
  // /api/v1/admin/retailer/accounts/unlink/{linkedRetailerAccountId}
  // Unlink Retailer Accounts,
  unlinkRetailer: "api/v1/admin/retailer/accounts/unlink",

  // Retailer tiers
  retailerTiers: "api/v1/admin/retailer/tiers/",

  //Become Retailer Request
  becomeRetailers: "api/v1/admin/info/retailer/request",
  //Consumers
  allConsumers: "api/v1/admin/info/consumer/details",

  // ImportpromoCode
  importpromocode: "api/v1/admin/loyalty/promocodes/excel/promocode/import",

  //Fee config
  getAllFeeDetails: "api/v1/payments/paymentFeeDetailsList",
  addFee: "api/v1/payments/paymentFeeDetails",
  configHistory: "api/v1/payments/paymentFeeHistoryDetailsList",
  editFee: "api/v1/payments/updatePaymentFeeDetails",
  feeDetailsById: "api/v1/payments/paymentFeeDetailsById",

  //batch export consumer
  createConsumerBatchExport: "api/v1/admin/reports/createConsumerBatchExport",
  consumerBatchExportList: "api/v1/admin/reports/consumerBatchExportList",

  // manage consumer
  manageConsumerPaymentReport: "api/v1/admin/reports/consumer/payment/report",

  // Refund apis
  creditCardRefund: "api/v1/payments/creditcard/refund",
  googlePayRefund: "api/v1/payments/googlepay/refund",
  paypalRefund: "api/v1/payments/paypal/refund",
};
